import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import cogoToast from "cogo-toast";
import { Consumer } from "../../context";
import Request from "../../core/httpClient";
import UnifiedDatePicker from '../../components/Calendario'; // ← Ajusta la ruta
import InputMask from 'react-input-mask';
const request = new Request();

const BlackoutDates = ({ idEspacio, context }) => {
    const [descripcion, setDescripcion] = useState('');
    const [fecha, setFecha] = useState(''); // ← sigue siendo string
    const [motivo, setMotivo] = useState('');
    const [fechasBloqueadas, setFechasBloqueadas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [loadRemoving, setLoadRemoving] = useState(false);

    useEffect(() => {
        getFechasBloqueadas();
    }, [idEspacio]);

    async function addDate(e) {
        e.preventDefault();
        setLoading(true);

        const user = await context.loadUser();

        if (user) {
            const data = {
                id_espacio: idEspacio,
                fecha_bloqueada: fecha, // ← string en formato YYYY-MM-DD
                motivo,
                usuario: user.id.nombre,
                fecha_upd: moment().format("YYYY-MM-DD HH:mm:ss"),
                tipo: 1
            };

            await saveData(data);
        } else {
            console.log("context.loadUser() devolvió null o undefined");
        }
    }

    async function removeDate(item) {
        setLoadRemoving(item.id);
        const user = await context.loadUser();

        if (user) {
            const data = {
                id_espacio: idEspacio,
                fecha_bloqueada: item.fecha,
                motivo: '',
                usuario: user.id.nombre,
                fecha_upd: moment().format("YYYY-MM-DD HH:mm:ss"),
                tipo: 2
            };
            await saveData(data);
        }
    }

    async function saveData(data) {
        try {
            const response = await request.post("/commonArea/bloquear/fecha", data);

            if (response) {
                if (response.error) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                }

                if (response.updated) {
                    if (data.tipo === 1) {
                        cogoToast.success("Fecha bloqueada agregada correctamente.", { position: "bottom-right" });
                        setFecha(''); // ← limpiar string
                        setMotivo('');
                    } else {
                        cogoToast.success("Fecha bloqueada eliminada correctamente.", { position: "bottom-right" });
                    }
                    await getFechasBloqueadas();
                }

                if (response.existe) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                    setFecha('');
                    setMotivo('');
                }
            }

            setLoading(false);
            setLoadRemoving(false);
        } catch (error) {
            console.log(error);
        }
    }

    async function getFechasBloqueadas() {
        try {
            setLoadingData(true);
            const response = await request.post("/commonArea/get/fechasBloqueadas", { id_espacio: idEspacio });

            if (response) {
                if (response.error) {
                    cogoToast.error(response.message, { position: "bottom-right" });
                }

                if (response.empty) {
                    setFechasBloqueadas([]);
                }

                if (response.fechas_bloqueadas) {
                    const arrayBloqueos = response.fechas_bloqueadas.map(row => ({
                        fecha: row.fecha_bloqueada,
                        motivo: row.motivo,
                        id: row.id
                    }));
                    setFechasBloqueadas(arrayBloqueos);
                }
            }

            setLoadingData(false);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="tw-flex tw-flex-col tw-w-full tw-items-center">
            <div className="tw-w-full tw-space-y-1.5 tw-text-xs">

                {/* Bloque políticas de uso */}
                <div className="tw-border tw-rounded-md tw-p-1.5 tw-shadow-sm">
                    <h3 className="tw-font-extrabold tw-mb-1 tw-text-lg tw-underline tw-text-purple-950">Políticas de uso</h3>
                    <textarea
                        name="descripcion"
                        rows="4"
                        autoComplete="off"
                        className="tw-w-full input-edit-sm tw-text-left"
                        value={descripcion}
                        onChange={(event) => setDescripcion(event.target.value)}
                    />
                </div>

                {/* Bloque fechas a bloquear */}
                <div className="tw-border tw-rounded-md tw-p-1.5 tw-shadow-sm tw-space-y-1.5">
                    <h3 className="tw-font-extrabold tw-mb-1 tw-text-lg tw-underline tw-text-purple-950">Fechas a bloquear</h3>

                    <div className="tw-grid tw-grid-cols-2 tw-gap-1.5">
                        {/* Formulario para agregar fecha */}
                        <form className="tw-flex tw-flex-col tw-gap-1.5" onSubmit={addDate}>
                            <div className="tw-flex tw-flex-col">
                                <label className="tw-font-semibold tw-mb-0.5 tw-text-xs tw-whitespace-nowrap">Fecha a bloquear:</label>

                                <UnifiedDatePicker
                                    selected={fecha ? moment(fecha, 'YYYY-MM-DD').toDate() : null}
                                    onChange={(date) => {
                                        setFecha(date ? moment(date).format('YYYY-MM-DD') : '');
                                    }}
                                    includeTime={false}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                    className="input-edit-sm tw-text-left tw-w-full"
                                    customInput={
                                        <InputMask
                                            mask="99/99/9999"
                                            maskChar={null}
                                            className="input-edit-sm tw-text-left tw-w-full"
                                            placeholder="DD/MM/YYYY"
                                        />
                                    }
                                />
                            </div>

                            <div className="tw-flex tw-flex-col">
                                <label className="tw-font-semibold tw-mb-0.5 tw-text-xs tw-whitespace-nowrap">Motivo:</label>
                                <input
                                    type="text"
                                    name="motivo"
                                    required
                                    className="input-edit-sm tw-text-left"
                                    value={motivo}
                                    onChange={(e) => setMotivo(e.target.value)}
                                />
                            </div>

                            <button
                                type="submit"
                                className="tw-bg-purple-700 hover:tw-bg-purple-800 tw-text-white tw-font-semibold tw-rounded tw-px-2 tw-py-1 tw-text-xs tw-w-full tw-transition"
                                onClick={addDate}
                            >
                                {loading ? <i className="fas fa-spinner fa-spin"></i> : 'Agregar'}
                            </button>
                        </form>

                        {/* Tabla de fechas bloqueadas */}
                        <div className="tw-border tw-rounded tw-overflow-hidden">
                            <table className="tw-w-full tw-text-xs">
                                <thead className="tw-bg-gray-100">
                                    <tr>
                                        <th className="tw-text-left tw-font-semibold tw-px-1.5 tw-py-1">Fecha bloqueada</th>
                                        <th className="tw-text-left tw-font-semibold tw-px-1.5 tw-py-1">Motivo</th>
                                        <th className="tw-text-center tw-font-semibold tw-px-1.5 tw-py-1">Quitar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loadingData ? (
                                        <tr>
                                            <td colSpan="3" className="tw-py-2">
                                                <div className="tw-flex tw-justify-center">
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : fechasBloqueadas.length !== 0 ? (
                                        fechasBloqueadas.map((item, i) => (
                                            <tr key={i} className="tw-border-t">
                                                <td className="tw-px-1.5 tw-py-1 tw-text-left">{moment(item.fecha).format("DD/MM/YYYY")}</td>
                                                <td className="tw-px-1.5 tw-py-1 tw-text-left">{item.motivo}</td>
                                                <td className="tw-px-1.5 tw-py-1 tw-text-center">
                                                    {loadRemoving === item.id ? (
                                                        <i className="fas fa-spinner fa-spin"></i>
                                                    ) : (
                                                        <i
                                                            className="fas fa-times-circle tw-text-red-600 tw-cursor-pointer"
                                                            onClick={() => removeDate(item)}
                                                        ></i>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="tw-py-2 tw-text-center">
                                                <h4 className="tw-font-semibold">No se encontraron resultados.</h4>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Consumer(BlackoutDates);